
import React from 'react';
import { Table } from '@/components/ui/table';
import { TransportationBody } from './TransportationBody';
import { TransportationTableHeader } from './TransportationTableHeader';
import { TransportationCaption } from './TransportationCaption';
import { ItineraryEvent } from '@/types/itinerary';

interface TransportationTableProps {
  events: ItineraryEvent[];
  onAddTransportation?: () => void;
}

export const TransportationTable: React.FC<TransportationTableProps> = ({ 
  events, 
  onAddTransportation 
}) => {
  return (
    <Table>
      <TransportationCaption onAddTransportation={onAddTransportation} />
      <TransportationTableHeader showEditColumn={true} />
      <TransportationBody events={events} />
    </Table>
  );
};
